// Owner addresses for the first 5 items of each collection
export const ownerAddresses = {
  pudgypenguins: {
    '8422': '0x79ffg...5d56',
    '407': '0x3dE2f7...d5f6',
    '3758': '0x8B2bd...523c',
    '495': '0x4F3a1C...2A5d',
    '3934': '0x2c3d4...8i9j'
  },
  azuki: {
    '301': '0x1a2b3c...7890',
    '5442': '0x2b3c4...8h9i',
    '7102': '0x3c4d5...9i0j',
    '469': '0x4d5e6f...0j1k',
    '1565': '0x5e6f7...1k2l'
  },
  doodles: {
    '2142': '0x6f7g8...2l3m',
    '4623': '0x7g8h9...3m4n',
    '7891': '0x8h9i0...4n5o',
    '3456': '0x9i0j1...5o6p',
    '9928': '0x0j1k2...6p7q'
  },
  'redacted-remilio-babies': {
    '9992': '0x4d55...0j1k',
    '9982': '0x5e6f...1k2l'
  }
};
